import { Box, CardHeader, Skeleton } from "@mui/material";
import { sxStyles } from "./TransactionHistoryProfileHeader.styles";
import { TransactionHistoryProfileHeaderProps } from "./TransactionHistoryProfileHeader.types";
import IMAGES from "lib/assets/images";
import IconTextButton from "lib/components/buttons/IconTextButton/IconTextButton";
import { useAppSelector } from "lib/redux/hooks";
import { selectUser } from "lib/redux/user/selectors";

const TransactionHistoryProfileHeader = ({
  title,
  showMFilterTransactionsButton = true,
  openFilterDialog,
}: TransactionHistoryProfileHeaderProps) => {
  const classes = sxStyles();
  const { patientName: name, isLoading } = useAppSelector(selectUser);

  return (
    <Box sx={classes.paymentPage}>
      <Box sx={classes.profileHeader}>
        <CardHeader
          title={
            isLoading ? (
              <Skeleton variant="text" animation="wave" width="60%" />
            ) : name ? (
              name + title
            ) : null
          }
          sx={classes.cardHeader}
        />

        {showMFilterTransactionsButton && (
          <Box sx={classes.filterTransactionsBox}>
            <IconTextButton
              icon={IMAGES.general.FilterIcon}
              label={["Filter", "transactions"]}
              onClick={openFilterDialog}
              ariaLabel={"Filter transactions"}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TransactionHistoryProfileHeader;
